import { useEffect, useState } from 'react';
import { recommendationsApi } from '../services/api';
import {
  DEFAULT_DEVICE_OPTION_SETS,
  mergeDeviceOptionSets,
  type DeviceOptionSets,
} from '../components/RecommendationDetails/deviceOptionDefaults';

/**
 * Listy „Typ urządzenia" zaleceń per-lokal (migr. 054) dla formularza lokalu w adminie.
 * Od razu stałe z kodu, potem API (edycje z zakładki „Zalecenia"); błąd API zostawia stałe —
 * formularz musi działać i bez tej listy (lustro mobilnego useDeviceOptionSets, bez cache).
 */
export function useDeviceOptionSets(enabled: boolean): DeviceOptionSets {
  const [sets, setSets] = useState<DeviceOptionSets>(DEFAULT_DEVICE_OPTION_SETS);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const fresh = await recommendationsApi.getDeviceOptions();
        if (!cancelled) setSets(mergeDeviceOptionSets(fresh.sets));
      } catch (error) {
        // Brak listy z API to nie błąd formularza — zostają stałe (PG/COG itd.).
        console.warn('Device option lists: using built-in defaults:', error);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return sets;
}
